module.exports = __webpack_public_path__ + "static/media/EasyWords_web_3_preview.9963ab05.jpg";